// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__hSuzy","emojiContainer":"About_emojiContainer__K26F7","emoji":"About_emoji__Y0kWj"};